@if (totalNotifications() > 0) {
<mat-accordion>
    <mat-expansion-panel [expanded]="true" (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
        <mat-expansion-panel-header class="header-centro">
            <mat-panel-title>
                <div class="icon-container rojo">
                    <!-- <i class="bi bi-bell"></i> -->
                    <app-icon color="#fff" strokeColor="#fff" [name]="'notificacion'" [strokeWidth]="5" size="2em">
                    </app-icon>
                </div>
                <div class="text">
                    <p class="text-title notificaciones-title">{{ 'HOME.NOTIFICACIONES' | translate }}</p>
                    <p>
                        {{ 'NOTIFICACIONES.MESSAGE' | translate:{ count: totalNotifications() }:
                        (totalNotifications() === 1 ? 'NOTIFICACIONES.MESSAGE' : 'NOTIFICACIONES.MESSAGE_PLURAL') }}
                    </p>

                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="notificaciones">
            @for (notification of notifications(); track $index) {
            <p>{{ `${notification.titleKey}_home` | translate: notification.titleParams }}</p>
            @if (!$last) {
            <hr>
            }
            }
        </div>

    </mat-expansion-panel>
</mat-accordion>
}